<template>
  <div id="tc-page" class="wp_AllPageMarginTop">
    <h5 style="text-align:center;" class="mb-4"
								data-test="termsAndConditionHeading1"
								id="termsAndConditionHeading1">
					THE NEO BANK
    </h5>
    <h5 style="text-align:left;"
								data-test="termsAndConditionHeading2"
								id="termsAndConditionHeading2"
				>
      Terms and Conditions
    </h5>
			<div v-for="(account, index) in termsData" :key="index">
				<p data-test="termsAndConditionPara1"
							id="termsAndConditionPara1" :style="account.isHead?'text-transform: capitalize':''">
					<!--<b data-test="termsAndConditionParaBold1"-->
					<!--id="termsAndConditionParaBold1">Personal Information:</b>-->
					{{account.body}}
				</p>
			</div>
  </div>
</template>

<script>
export default {
	data () {
		return {
			termsData: [
				{
					body: 'The Neo Bank (the “Site”) is operated by The Neo Bank (the “Bank” or “we”).  Users of the Site, including visitors, are subject to the Site’s terms and conditions (the “Terms of Use”).',
					isHead: false
				}, {
					body: 'PLEASE CAREFULLY READ THESE TERMS OF USE BEFORE USING THIS SITE:',
					isHead: true
				}, {
					body: 'The Neo Bank, located in Wilmington, DE, requires that all visitors to the Site adhere to the following terms and conditions. By accessing the Site you indicate your acknowledgment and acceptance of these terms and conditions.',
					isHead: false
				}, {
					body: 'You agree that your use of this Site shall be governed by Delaware law and agree that jurisdiction and venue shall be located in Wilmington, Delaware.',
					isHead: false
				}, {
					body: 'The Bank maintains this Site to provide you with information about Bank products and services and to facilitate communication with the Bank and its related companies. From time to time the Bank may revise these Terms of Use.',
					isHead: false
				}, {
					body: 'Copyright in the images, text, screens, and web pages appearing at the Site are owned by the Bank or others as indicated. You may copy information from the Site for your personal or educational use only, provided that each copy includes any copyright, trademark or service mark notice or attribution as they appear on the copied pages. The information and materials may not otherwise be copied, displayed, distributed, downloaded, licensed, modified, published, reposted, reproduced, reused, sold, transmitted, used to create a derivative work or otherwise used for public or commercial purposes, except as provided in these Terms of Use without the express written permission of the Bank',
					isHead: false
				},
				{
					body: 'Not all of the products or services described on the Site are available in all geographic areas. You may not be eligible for all the products or services described. The Bank reserves the right to determine eligibility for any product or service. Investment products and services offered through the Site (i) are not bank deposits and are not insured by the FDIC, (ii) are not bank guaranteed, and (iii) are subject to substantial risk, including the possible loss of some or all of the principal invested.',
					isHead: false
				}, {
					body: 'Unless otherwise prohibited by law, any communication or material you transmit to the Bank via the Site or Internet electronic mail is on a non-confidential basis and the Bank may use such communication or material for any legal purpose whatsoever, including reproduction, publication, broadcast and posting. We will use our best efforts to include accurate and up to date information on the Site, but we make no warranties or representations as to the accuracy of the information. You agree that all access and use of the Site and its contents is at your own risk. By using the Site, you acknowledge that we specifically disclaim any liability (whether based in contract, tort, strict liability or otherwise) for any direct, indirect, incidental, consequential, or special damages arising out of or in any way connected with your access to or use of the Site, (even if we have been advised of the possibility of such damages) including liability associated with any viruses which may infect a user\'s computer equipment.',
					isHead: false
				}, {
					body: 'With regard to services or products purchased or obtained by you through the Site from a person or entity other than the Bank, we make no warranty of merchantability or warranty of fitness for a particular purpose with regard to such services and products and the Bank specifically disclaims all other warranties with regard to such services or products.',
					isHead: false
				}
			]
		}
	}
}
</script>

<style lang="scss">
#tc-page {
  font-family: "Nunito Sans", sans-serif;
  text-align: justify;
  padding: 35px;
  padding-top: 70px;

  b {
    color: rgb(63, 63, 63);
  }
}
</style>
